import React from 'react';
import ReactDOM from 'react-dom';
import AvailabilityNotification from '../../Components/AvailabilityNotification/AvailabilityNotification';

const productAvailabilityContainer = document.querySelectorAll(
    '.js-product-availability-form',
) as NodeListOf<HTMLElement>;

export default function ProductAvailabilityIntegrations() {
    return (
        <>
            {[...productAvailabilityContainer].map((container) => {
                const articleNumber = container.dataset.articleNumber || '';
                return ReactDOM.createPortal(<AvailabilityNotification articleNumber={articleNumber} />, container);
            })}
        </>
    );
}
